// extracted by mini-css-extract-plugin
export var table = "tier-module--table--5CSKR";
export var headerIcon = "tier-module--headerIcon--CJ1wc";
export var productName = "tier-module--productName--oHt+x";
export var productPrice = "tier-module--productPrice---exnV";
export var mobileTierDetails = "tier-module--mobileTierDetails--Jn2nN";